<template>
    <div>
        <input type="hidden" name="_token" :value="csrf" />
        <input type="hidden" name="customer" :value="customer" />
        <input type="hidden" name="order" :value="currentOrder ? currentOrder.id : 0" />
        <input
            type="hidden"
            name="promoCodesImpact"
            :value="
                c_cartItems
                    ? JSON.stringify(
                          Object.values(c_cartItems)
                              .map(x => x.codePromo)
                              .filter(x => x.length)
                      )
                    : null
            "
        />
        <input type="hidden" name="totalDiscount" :value="totalDiscount" />

        <!-- <input
            v-if="accompte && this.promoCode"
            type="hidden"
            name="total"
            :value="
                parseFloat(
                    cartTotal -
                        accompte -
                        this.promoCode.discount_amount * (((this.cartTotal - this.accompte) * 100) / this.cartTotal / 100)
                ).toFixed(2)
            "
        />
        <input
            v-if="accompte && !this.promoCode"
            type="hidden"
            name="total"
            :value="parseFloat(cartTotal - accompte).toFixed(2)"
        />

        <input
            v-if="rest && this.promoCode"
            type="hidden"
            name="total"
            :value="
                parseFloat(
                    totalWRest -
                        this.promoCode.discount_amount * (((this.cartTotal - this.rest) * 100) / this.cartTotal / 100) +
                        this.promoCode.discount_amount
                ).toFixed(2)
            "
        />
        <input v-if="rest && !this.promoCode" type="hidden" name="total" :value="parseFloat(totalWRest).toFixed(2)" />

        <input
            v-if="!rest && !accompte && this.promoCode"
            type="hidden"
            name="total"
            :value="
                parseFloat(cartTotal - this.promoCode.discount_amount * ((this.cartTotal * 100) / this.cartTotal / 100)).toFixed(
                    2
                )
            "
        />

        <input
            v-if="!rest && !accompte && !this.promoCode"
            type="hidden"
            name="total"
            :value="parseFloat(cartTotal).toFixed(2)"
        /> -->

        <!-- <input v-if="this.promoCode" type="hidden" name="promo" :value="JSON.stringify(selectCode)" /> -->
        <input v-if="accompte" type="hidden" name="status" :value="'account'" />
        <input v-if="rest" type="hidden" name="status" :value="'rest'" />
        <input v-if="!rest && !accompte" type="hidden" name="status" :value="'total'" />

        <div class="row">
            <h3 class="h6 block-title border-bottom ps-0">
                <i class="text-primary fa fa-fw fa-credit-card text-muted me-1"></i>
                Moyens de paiements
            </h3>

            <div
                v-for="(method, index) in c_payments.filter(x => !x.isRemisePersonalisee)"
                :key="index"
                class="col-6 col-md-4"
                :style="
                    !method.name.includes('Abonnement') && !method.name.includes('Cure') && !method.name.includes('cadeau')
                        ? ''
                        : 'padding: 0px; height: 0px'
                "
            >
                <PaymentCard :method="method" :remainPrice="c_remainPrice">
                    <template #checkbox>
                        <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            :id="'checkbox_' + method.name"
                            :name="'checkbox_' + method.name"
                            @change="selectPaymentMethod($event, method)"
                            :style="'border:'"
                        />
                    </template>
                    <template #input>
                        <input
                            type="number"
                            class="form-control form-control-sm disabled"
                            :name="'payments[' + method.name + ']'"
                            :id="'payments[' + method.name + ']'"
                            min="1"
                            :max="c_remainPrice"
                            :ref="'input_' + method.name"
                            @input="if(method.value < 0) { method.value = 0; }"
                            v-model="method.value"
                            readonly
                            style="min-width: 5rem;"
                        />
                    </template>
                </PaymentCard>
            </div>

            <PaymentStripe :userId="userId" :orderId="orderId"></PaymentStripe>
            <PaymentKlarna :userId="userId" :orderId="orderId" :currentOrder="currentOrder"></PaymentKlarna>

            <h3 class="h6 block-title border-bottom ps-0 mt-4">
                <i class="text-yellow fa fa-fw fa-percent text-muted me-1"></i>
                Réductions spécifiques
            </h3>

          
            <div
                class="col-6 col-md-8"
            >
                <div class="d-flex flex-column w-100">
                    <span class="h6 fw-medium my-auto">Code promo :</span>
                    <select @change="selectPromoCode($event)" class="form-select" name="promo_code" id="promo-code-select">
                        <option value selected>Aucun</option>
                        <option v-for="promoCode in promoCodes" :key="promoCode.id" :value="promoCode.code"
                        >{{ promoCode.title }}
                            <span class="mx-5">-----</span>
                            {{ promoCode.discount_amount }}
                            {{ promoCode.discount_type == 'fixed' ? 'euro' : '%' }}
                            <span class="mx-5">-----</span>
                            {{ promoCode.is_global ? '(remise globale)' : '' }}</option
                        >
                    </select>
                    <div v-if="currentPromoCode" class="mb-3">
                        <span v-if="infoPromoCode" class="text-info">{{ infoPromoCode }}</span>
                        <span v-if="errorPromoCode" class="text-danger">{{ errorPromoCode }}</span>
                    </div>
                    <button
                        style="width: max-content;margin: 0 0 0 auto;"
                        type="button"
                        :class="errorPromoCode ? 'text-light btn-danger' : 'btn-yellow'"
                        class="btn align-items-center  px-4 py-2"
                        @click="applyPromoCode"
                    >
                        Appliquer
                    </button>
                    <div v-if="c_promoCodes">
                        <div
                            v-for="(code, i) in c_promoCodes"
                            :key="i"
                            class="rounded mt-4 p-4 pb-0 bg-white d-flex justify-content-between"
                        >
                            <div>
                                <p class="fw-bold mb-1">
                                    {{ code.title }} - {{ code.code }}
                                    <span class="badge bg-primary "
                                    >-{{ code.discount_amount }}{{ code.discount_type == 'percentage' ? '%' : '€' }}</span
                                    >
                                </p>
                                <p>{{ code.description }}</p>
                            </div>
                            <div>
                                <a @click="deleteCode(i)" style="cursor: pointer"><i class="fa fa-times"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { get, sync } from 'vuex-pathify'
import PaymentCard from './PaymentCard.vue'
import InitManager from '../../Checkout_BO/CheckoutOverlay/_core/InitManager'
import ApiManager from '../../Checkout_BO/CheckoutOverlay/_core/ApiManager'
import PaymentStripe from './PaymentStripe.vue'
import PaymentKlarna from './PaymentKlarna.vue'

export default {
    props: [
        // Customer
        // Object type : USER
        'customer',

        // Promo codes
        'promoCodes',
        'promoCode',

        // Payment
        'paymentMethods',
        'usedFidelityPoints',

        // Numbers and totals
        'cartTotal',
        'rest',
        'accompte',
        'currentOrder',
        'promotions',
        'userId',
        'orderId',
    ],
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        currentPromoCode: null,
        codeApplicable: false,
        totalDiscount: 0,
        errorPromoCode: null,
        infoPromoCode: null,
        copyCards: null,
    }),
    computed: {
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_tmpPromoCodes: 'tmpPromoCodes',
        }),
        ...sync('overlay@data', {
            c_cartItems: 'cartItems',
            c_payments: 'payments',
            c_promoCodes: 'promoCodes',
        }),
    },
    components: {
        PaymentCard,
        PaymentStripe,
        PaymentKlarna
    },
    watch: {
        c_tmpPromoCodes: {
            handler(val, prev) {
                if (!val || !val.length || !prev || prev.length) return

                val.forEach(t => {
                    this.selectPromoCode({ target: { value: t.code } })
                        .then(() => this.applyPromoCode())
                        .then(() => {
                            // console.log(this.c_promoCodes, this.promotions, this.c_cartItems);
                            this.promotions.forEach(p => {
                                const cartItem = this.c_cartItems[p.item_order_id]
                                const promoCode = cartItem && cartItem.code
                                    ? cartItem.code.find(x => x.id == p.promotion_id)
                                    : null

                                if (p.real_amount == 0 && promoCode) {
                                    promoCode.enable = false
                                }
                            })
                        })
                })
            },
            deep: true,
        },
        c_cartItems: {
            handler(val, prev) {
                if (val && prev && Object.keys(val).length && !Object.keys(prev).length)
                    this.copyCards = JSON.parse(JSON.stringify(this.c_cartItems))
            },
            deep: true,
        },
    },
    methods: {
        selectPaymentMethod(event, data) {
            if (event.target.checked) {
                this.$refs['input_' + data.name][0].removeAttribute('readonly')
                if (!this.c_payments.find(x => x.value != 0)) {
                    data.value = this.c_remainPrice
                } else if (this.c_remainPrice != 0) {
                    data.value = this.c_remainPrice
                }
            } else {
                this.$refs['input_' + data.name][0].setAttribute('readonly', true)
                data.value = 0
            }
        },

        // Get baskets item who is targeted by promoCode
        async _getEligibleCards(cards, promoCode, type,type_model) {
                           

            const res = type.includes('categories')
                ? // Check same categories
                  await this._asyncFilter(cards, async card => {
                      const categoryId = await ApiManager.getItemCategory(card.options.item_id, card.options.type).then(
                          res => res.data
                      )
                     
                      return promoCode[type].find(p => p.id == categoryId&&card.options.type==type_model) != null
                  })
                : // Check same type
                  cards.filter(card =>
                      promoCode[type]?.find(
                          p => p.id == card.options.item_id && (type === 'packages'
                              ? card.options.type === type_model
                              : card.options.type.toLowerCase().includes(type.slice(0, -1)))
                      )
                  )
            return res
        },

        async _asyncFilter(values, func) {
            const shouldFilter = await Promise.all(values.map(func))
            return values.filter((value, index) => shouldFilter[index])
        },

        // Check validity of code promo
        _isAnInvalidCodePromo(promoCode) {
            if (promoCode.isExpired) return 'Le code promo a expiré.'
            if (promoCode.expiration_date && moment(promoCode.expiration_date).toDate() < new Date())
                return `Le code promo a expiré depuis le ${promoCode.expiration_date}.`
            if (promoCode.disabled) return `Le code promo est désactivé.`
            if (promoCode.uses != null && promoCode.uses <= 0)
                return `Le nombre maximum d'utilisation du code promo à été atteint.`
            return null
        },

        _computeAmountCodePromo(amount, currentCode) {
            let res = 0
            if (currentCode.discount_type == 'fixed') {
                res = amount > currentCode.discount_amount ? currentCode.discount_amount : amount
            } else if (currentCode.discount_type == 'percentage') {
                res = amount * (currentCode.discount_amount / 100)
            }
            return res
        },

        // Get amount of remise of promoCode
        async _getTotalRemise(cardsObj, promoCodeTxt) {
            var cards = Object.keys(cardsObj).map(function(key) {
                cardsObj[key]._key = key
                return cardsObj[key]
            })
            var currentCode = await ApiManager.getPromoCode(promoCodeTxt)

            // If error back return error string
            if (!currentCode || typeof currentCode === 'string')
                return { error: currentCode || "Une erreur interne c'est produite" }

            // check basic errors
            const error = this._isAnInvalidCodePromo(currentCode)
            if (error) return { error: error, currentCode }

            // [GLOBAL]
            if (currentCode.is_global) {
                // if (currentCode.discount_type == 'fixed') currentCode.linked_cart_items = cards && cards[0] ? [cards[0]] : []
                currentCode.linked_cart_items = [...cards]
                return { currentCode }
            }

            // [NOT GLOBAL]
            else {
                let ttlist = []
                console.log(JSON.stringify(currentCode));
                if (currentCode.products && currentCode.products.length > 0)
                    ttlist = ttlist.concat(await this._getEligibleCards(cards, currentCode, 'products','App\\Models\\Product\\Product'))
                if (currentCode.prestations && currentCode.prestations.length > 0)
                    ttlist = ttlist.concat(await this._getEligibleCards(cards, currentCode, 'prestations','App\\Models\\Prestation\\Prestation'))
                if (currentCode.product_categories && currentCode.product_categories.length > 0)
                    ttlist = ttlist.concat(await this._getEligibleCards(cards, currentCode, 'product_categories','App\\Models\\Product\\Product'))
                if (currentCode.prestation_categories && currentCode.prestation_categories.length > 0)
                    ttlist = ttlist.concat(await this._getEligibleCards(cards, currentCode, 'prestation_categories','App\\Models\\Prestation\\Prestation'))
                if (currentCode.packages && currentCode.packages.length > 0)
                    ttlist = ttlist.concat(await this._getEligibleCards(cards, currentCode, 'packages', 'App\\Models\\Package'))
                if (currentCode.treatments && currentCode.treatments.length > 0)
                    ttlist = ttlist.concat(await this._getEligibleCards(cards, currentCode, 'treatments','App\Models\Treatment'))

                let ids = []
               
                ttlist = ttlist.filter(v => {
                    if (!ids.find(id => id === v._key)) {
                        ids.push(v._key)
                        return true
                    }
                    return false
                })
                
                currentCode.linked_cart_items = [...ttlist]
                return { currentCode }
            }
        },

        async selectPromoCode(event) {
            this.errorPromoCode = null
            this.infoPromoCode = null
            console.log(this.c_promoCodes)
            if (event.target.value !== '') {
                const res = await this._getTotalRemise(this.c_cartItems, event.target.value)
// ici faire le test applicable ou nn
                if (res.error) this.errorPromoCode = res.error
                if (!res.currentCode) return

                if (this.c_promoCodes.find(x => x.id == res.currentCode.id)) {
                    this.errorPromoCode = `Code promo déjà utilisé.`
                  

                    return
                }
if(!this.checkIfApplyPromoCode(res.currentCode)){
 this.errorPromoCode = `Code promo non applicable.`
    return
}
                this.infoPromoCode = 'Code promo applicable.'
                this.currentPromoCode = res.currentCode
            } else {
                this.errorPromoCode = `Code promo introuvable.`
            }
            return this.currentPromoCode
        },

        checkIfApplyPromoCode(promoCode) {
            let isApplied=false
            if (this.c_promoCodes.find(x => x.id == promoCode.id)) {
                return
            }
          
            
            if(promoCode.has_voucher){
            for (const key in this.c_cartItems) {

                        if (this.c_cartItems[key].options.type === 'App\\Models\\Voucher\\Voucher') {
                            // Init

                          
                            isApplied=true
                             
                        }
                    }
            }
            if (promoCode.linked_cart_items) {

                promoCode.linked_cart_items.forEach(card => {
                    for (const key in this.c_cartItems) {
                        if (this.c_cartItems[key].id === card.id) {
                            // Init
                              isApplied=true
                        }
                    }
                })
            }

              return isApplied
        },



        applyPromoCode() {
        console.log(this.currentPromoCode);
 if(!this.currentPromoCode)
 return
            if (this.c_promoCodes.find(x => x.id == this.currentPromoCode.id)) {
                return
            }
            if (this.currentPromoCode) this.c_promoCodes.push(this.currentPromoCode)
         
            if(this.currentPromoCode.has_voucher){
            for (const key in this.c_cartItems) {

                        if (this.c_cartItems[key].options.type === 'App\\Models\\Voucher\\Voucher') {
                            // Init

                            if (!this.c_cartItems[key]._oldPrice) this.c_cartItems[key]._oldPrice = this.c_cartItems[key].price
                            if (!this.c_cartItems[key].code) this.c_cartItems[key].code = []

                            // Push code
                            this.c_cartItems[key].code.push({
                                id: this.currentPromoCode.id,
                                title: this.currentPromoCode.title,
                                amount: `${this.currentPromoCode.discount_amount}${
                                    this.currentPromoCode.discount_type == 'fixed' ? '€' : '%'
                                }`,
                                discount_type: this.currentPromoCode.discount_type,
                                discount_amount: this.currentPromoCode.discount_amount,
                                enable: true,

                                has_voucher: this.currentPromoCode.has_voucher,

                                global: this.currentPromoCode.is_global,
                                last: this.currentPromoCode.is_global && this.currentPromoCode.discount_type == 'fixed' ? 1 : 0,
                            })
                            //this.c_cartItems[key].code.sort((a, b) => a.last - b.last)
                        }
                    }
            }
            if (this.currentPromoCode.linked_cart_items) {

                this.currentPromoCode.linked_cart_items.forEach(card => {
                    for (const key in this.c_cartItems) {
                        if (this.c_cartItems[key].id === card.id) {
                            // Init

                            if (!this.c_cartItems[key]._oldPrice) this.c_cartItems[key]._oldPrice = this.c_cartItems[key].price
                            if (!this.c_cartItems[key].code) this.c_cartItems[key].code = []

                            // Push code
                            this.c_cartItems[key].code.push({
                                id: this.currentPromoCode.id,
                                title: this.currentPromoCode.title,
                                amount: `${this.currentPromoCode.discount_amount}${
                                    this.currentPromoCode.discount_type == 'fixed' ? '€' : '%'
                                }`,
                                discount_type: this.currentPromoCode.discount_type,
                                discount_amount: this.currentPromoCode.discount_amount,
                                enable: true,

                                has_voucher: false,

                                global: this.currentPromoCode.is_global,
                                last: this.currentPromoCode.is_global && this.currentPromoCode.discount_type == 'fixed' ? 1 : 0,
                            })
                            this.c_cartItems[key].code.sort((a, b) => a.last - b.last)
                        }
                    }
                })
            }




            this.infoPromoCode = null
            this.errorPromoCode = null
        },

        async deleteCode(index) {
            this.currentPromoCode = null
            const newPromo = [...this.c_promoCodes]
            newPromo.splice(index, 1)
            this.c_promoCodes = []

            // restore
            this.c_cartItems = JSON.parse(JSON.stringify(this.copyCards))

            // re-apply promo
            for (let i = 0; i < newPromo.length; i++) {
                const p = newPromo[i]
                await this.selectPromoCode({ target: { value: p.code } })
                    .then(() => this.applyPromoCode())
                    .then(() => {})
            }
        },
    },
}
</script>

<style>
#promo-code-select {
    margin: 15px 0px;
    width: 100%;
}
</style>
